import type { User } from '@/@types/user'
import { Fragment, type HTMLAttributes } from 'react'
import ScreenName from './ScreenName'
import styles from './ScreenNames.module.css'

export interface ScreenNamesProps extends HTMLAttributes<HTMLDivElement> {
	data: User[]
}

export default function ScreenNames({ data, ...props }: ScreenNamesProps) {
	return (
		<span className={styles.root}>
			{data.map((user, index) => (
				<Fragment key={user.id}>
					<ScreenName data={user} />
					{index !== data.length - 1 && <span>、</span>}
				</Fragment>
			))}
		</span>
	)
}
